import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TxtHighlightPipe } from '@common-standalone/pipes/text-highlight.pipe';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { TAGGING_ERRORS } from '@mainrepo/app/core/constants/TaggingErrors';
import { AddHashTagController } from '@mainrepo/app/core/controller/AddHashTagController';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { debounceTime, tap } from 'rxjs/operators';
import { DiscardHashTagsComponent } from '../discard-hash-tags/discard-hash-tags.component';
import { HashTagInfoComponent } from '../hash-tag-info/hash-tag-info.component';
import { RecentHashTagsComponent } from '../recent-hash-tags/recent-hash-tags.component';
export enum KEY_CODE {
  TOP_ARROW = 38,
  BOTTOM_ARROW = 40
}
@Component({
  standalone:true,
  selector: 'app-add-hash-tag',
  templateUrl: './add-hash-tag.component.html',
  styleUrls: ['./add-hash-tag.component.scss'],
  imports:[DependenciesModule,RecentHashTagsComponent,HashTagInfoComponent,DiscardHashTagsComponent,TxtHighlightPipe]
})
export class AddHashTagComponent implements OnInit {
  public universalService:any;
  public controller:any;
  public implRef:any;
  public showHashTagModal:boolean = false;
  public listService:any;
  public showDiscard:any;
  public stringPasted:boolean = false;
  showInfoModal:boolean = false;
  static addHashTag: any;
  public placeholderText:any = "Max Limit Reached";
  public paste:boolean = false;
  cleverTapEventsService: any;
  spaceBarClicked:boolean = false;
  tagForm: FormGroup;
  currentSuggestion: any;
  tagSuggestions: any;
  searchService: any;
  currentIndex:any;

  constructor(public globalService:GlobalService,private formBuilder: FormBuilder) {
    AddHashTagComponent.addHashTag = this;
    this.setEnvObjects(globalService);
    window.addEventListener('paste', async (event) => {
      if(!this.showHashTagModal) return
      this.paste = true;
      var pastedData = (event["clipboardData"] || window["clipboardData"]).getData('text')
      pastedData = pastedData.replace(' ','')
      await this.implRef.objectPasted(pastedData)
      this.paste = false;
      //this.implRef.clearInputField();
    })
   }

   @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.keyCode === KEY_CODE.BOTTOM_ARROW && this.tagSuggestions && this.tagSuggestions.length != 0){
      this.goToNextResult()
    }else if (event.keyCode === KEY_CODE.TOP_ARROW && this.tagSuggestions && this.tagSuggestions.length != 0){
      this.goToPreviousResult();
      //Bring focus on end of text on up key
      setTimeout(()=>{
        let tagInput = <HTMLInputElement>document.getElementById("tagInput");
        let inputTag =  document.getElementsByClassName("inpt-tags");
        let len = tagInput.value.length;
        (<HTMLInputElement>document.getElementById("tagInput")).focus();
        tagInput.setSelectionRange(len, len);
      })
    }else if (event.key === "Escape" && this.showHashTagModal) {
      this.showDiscardModal();
    }else if (event.key === "Enter" && this.implRef.enableButton && this.showHashTagModal && !$('.inpt-tags').focus()){
      this.implRef.resetErrorDefaultMsg();
      this.saveChanges();
    }else if ((event.key === ' ' || event.key === 'Spacebar') && this.showHashTagModal){
      this.addTagOnEnter(this.implRef.currentTagName);
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(this.showHashTagModal &&  event.target.id != 'hashTagInfoBtn' &&this.showInfoModal && event.target.id !='hash-tag-info-list-cont' && event.target.parentElement.id !='hash-tag-info-list-cont' && !event.target.classList.contains('info-popover')){
      this.showInfoModal = false; 
    }
  }

  ngOnInit(): void {
    this.controller = AddHashTagController.getInstance(this.globalService);
    this.implRef = this.controller.addHashTagImplementation;
    this.controller.setEnvObjects(this.globalService);
    this.implRef.showTagAutoSuggestion = false;
    this.registerEvents();
    this.initializeTagSuggestion()
    AppEvents.optionSelected.subscribe(event=>{
      if(event["addHashTag"]){
        this.initComp();
      }
    })
  }
  

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
    this.searchService = globalService.getSearchServiceRef();

  }

  async initComp(){
    this.cleverTapEventsService.addManualTag()

    this.resetValues();
    var result = await this.controller.getHashTagsForTheObject();
    if(result){
      this.showHashTagModal = true;
      this.universalService.popUpToBeOpened = "hashTagPopUp"
      this.implRef.focusOnInputField();
    }
  }

  resetValues(){
    this.implRef.resetErrorDefaultMsg();
    this.universalService.showLoader = true;
    this.implRef.existingTagsList = [];
    this.implRef.removedTagsList = [];
    this.implRef.newTagsList = [];
    this.implRef.recentsTagsList = [];
    this.implRef.maxLimitError = false;
    this.implRef.enableButton = false;
    this.showInfoModal = false;
    this.implRef.selectedObject = this.universalService.selectedFile;
  }

  async saveChanges(){
    if(this.implRef.hashTagError.msg != ''){
      this.implRef.showTagAutoSuggestion = false;
    }
    if(!this.universalService.connectionStatus){
      this.implRef.showNoInternetToast();
      return
    }
    var newChangesMade = this.implRef.checkIfChangesMade();
    if(!newChangesMade){
      this.showToastAfterSaving();
      return
    }
    this.universalService.showLoader = true;
    var result = await this.controller.updateHashTags(this.implRef.newTagsList,this.implRef.removedTagsList);
    if(result == "emptyTags"){
      this.implRef.setErrorMsg(TAGGING_ERRORS["BLUR_EVENT_ERROR"],true);
      this.universalService.showLoader = false;
    }else if(result){
      this.showToastAfterSaving()
    }
  }

  showToastAfterSaving(){
    if(this.implRef.newTagsList.length>0 && this.implRef.removedTagsList.length == 0 && this.implRef.existingTagsList.length == 0){
        this.universalService.showToast(TAGGING_ERRORS["TAGS_ADDED_MSG"],"success");
    }
    // else if (this.implRef.removedTagsList.length>0 && this.implRef.newTagsList.length==0){
    //   this.universalService.showToast(TAGGING_ERRORS["TAGS_REMOVED_MSG"],"success");
    // }
    else{
      this.universalService.showToast(TAGGING_ERRORS["TAGS_UPDATED_MSG"],"success");
    }
    this.showHashTagModal = false;
    this.listService.deSelectAll();
  }

  showDiscardModal(){
    if(this.implRef.currentTagName != "" || this.implRef.newTagsList.length > 0 || this.implRef.removedTagsList.length > 0){
      this.showDiscard = true
    }else if(this.implRef.enableButton){
      this.showDiscard = true;
    }else{
      this.implRef.checkIfEnableSaveButton();
      if(this.implRef.enableButton){
        this.showDiscard = true
      }else{
        this.discardConfirmation('yes')
      }
    }
  }

  discardConfirmation(action){
    this.implRef.showTagAutoSuggestion = false;
    if(action=="yes"){
      this.showDiscard = false;
      this.tagForm.get('tagName').setValue(null);
      this.implRef.clearInputField();
      this.showHashTagModal = false;
      this.listService.deSelectAll();
    }else{
      this.showDiscard = false;
      if(this.tagForm.get('tagName').value != "" && this.tagForm.get('tagName').value != null){
        setTimeout(() => {
          $('.inpt-tags').focus()
          this.implRef.setErrorMsg(TAGGING_ERRORS["BLUR_EVENT_ERROR"],true);
        }, 10);
      }
    }
  }
  fetchUpdatedTag(tag,event){  
    if(this.universalService.show2FApopUp){
      return
    }else if( event.data && (event.data[event.data.length - 1] == ' ')){ // detect the space bar click
      this.addTagOnEnter(tag)
      return
    }
    let inputType = event.inputType; //console.log(inputType);
    if(!this.universalService.connectionStatus){
      this.implRef.showNoInternetToast();
      return
    }
    if(tag.length > 0 &&  inputType!='insertFromPaste'){
        this.implRef.currentTagName = tag;
        if(tag.length>30){
          tag = tag.substring(0,30);
          setTimeout(() => {
            $(".inpt-tags").val(tag)
          });
        }
        this.implRef.validateTag(tag);
        if(this.implRef.enableButton){
          this.implRef.checkIfEnableSaveButton();
        }  
    }else if (tag.length == 0){
      this.implRef.currentTagName = tag
      this.implRef.resetErrorDefaultMsg();
      this.implRef.checkIfEnableSaveButton();
    }
  }

  async addTagToObject(tag){
    if(this.implRef.enableButton || (this.implRef.newTagsList.length == 0 && this.implRef.existingTagsList == 0)){
      await this.implRef.checkIfConditionsMetForAddingTheTag(tag);
      if(this.implRef.enableButton){
        this.implRef.showTagAutoSuggestion = false;
        this.tagForm.get('tagName').setValue(null);
        this.implRef.addTagToObject(tag)
      }
    }
  }

  async addSuggestedTagToObject(tag){
    this.tagForm.get('tagName').setValue(null);
    this.implRef.showTagAutoSuggestion = false;
    this.implRef.addTagToObject(tag);
  }

  async addTagOnBlur(tag,event){
    if(event.relatedTarget.classList.contains("suggestionRow")){ // this is added because, if the user selects a tag from the suggestions dropdown, the this blur event is getting triggered and it is not calling the actual function which is written on suggestions click, hence this check is added
      this.addSuggestedTagToObject(event.relatedTarget.id)
      return
    }
    if(this.universalService.show2FApopUp){
      return
    }else if(this.spaceBarClicked && this.universalService.isMobileDevice){
      this.spaceBarClicked = false;
      return
    }
    if(!this.universalService.connectionStatus){
      this.implRef.showNoInternetToast();
      return
    }
    if(tag.length != ""){
      this.implRef.currentTagName = tag;
      this.implRef.validateTag(tag);
    }
    if(this.implRef.currentTagName != "" && $('.inpt-tags').focus() && this.implRef.enableButton){
      await this.implRef.checkIfConditionsMetForAddingTheTag(tag);
      if(this.implRef.enableButton){
        tag = "#"+tag;
        var newTagIndex = this.implRef.newTagsList.indexOf(tag);
        var existingTagIndex = this.implRef.existingTagsList.findIndex(existingTag => existingTag.tag == tag);
        var recentTagIndex = this.implRef.recentsTagsList.findIndex(recentTag => recentTag.tag == tag);
        if((recentTagIndex >= 0 && (newTagIndex != -1 || existingTagIndex != -1)) || newTagIndex >= 0 || existingTagIndex >= 0){
          this.implRef.showTagAutoSuggestion = false;
          this.implRef.setErrorMsg(tag + TAGGING_ERRORS["TAG_ALREADY_EXISTS"],true);
          this.implRef.enableButton = false;
        }else{
          if(this.implRef.showTagAutoSuggestion){
            this.implRef.checkIfEnableSaveButton();
            return
          }else{
            this.implRef.showTagAutoSuggestion = false;
            this.implRef.setErrorMsg(TAGGING_ERRORS["BLUR_EVENT_ERROR"],true);
            this.implRef.checkIfEnableSaveButton();
          }
        }
        return;
      }
    }
    // this.addTagToObject(tag);
  }

  removeTag(tag){
    if(!this.universalService.connectionStatus){
      this.implRef.showNoInternetToast();
      return
    }
    this.implRef.showTagAutoSuggestion = false;
    this.implRef.removeTag(tag);
  }
  
  showInformation(){
    if(!this.universalService.connectionStatus){
      this.implRef.showNoInternetToast();
      return
    }
    this.showInfoModal = !this.showInfoModal;
  }

  addTagOnEnter(tag){
    this.spaceBarClicked = true;
    if(tag.length == ""){
      this.implRef.checkIfEnableSaveButton();
      return
    }
    this.implRef.validateTag(tag);
    if(this.implRef.enableButton){
      this.tagForm.get('tagName').setValue(null);
      this.implRef.showTagAutoSuggestion = false;
      this.addTagToObject(tag);
      setTimeout(() => {
         this.implRef.checkIfEnableSaveButton();
      }, 100);
      
    }
  }

  registerEvents(){
    let classRef = AddHashTagComponent.addHashTag;
    AppEvents.on(EventsList.INTERNET_OFF, function(){
      if(classRef.universalService.popUpToBeOpened == "hashTagPopUp"){
        classRef.implRef.showNoInternetToast();
      }
      $('.inpt-tags').addClass("readOnly");
      classRef.implRef.showTagAutoSuggestion = false;
      classRef.placeholderText = "";
    })
    AppEvents.on(EventsList.INTERNET_ON, function(){
     classRef.placeholderText = "Max Limit Reached"
     $('.inpt-tags').removeClass("readOnly");
     $('.inpt-tags').focus();
     classRef.implRef.showTagAutoSuggestion = false;
     classRef.implRef.resetErrorDefaultMsg();
    })
  }

  get tagName() {  // Getter function for searchQuery value - To be used a property
    return this.tagForm.get('tagName').value
  }
  
  initializeTagSuggestion(){
    let self = this;
    this.resetCurrentIndexAndSuggestions();
    this.tagForm = this.formBuilder.group({
      tagName: ['', Validators.minLength(3)],
    });
    // Subscription to search query values changes
    this.tagForm.get('tagName').setValue(null);
    this.tagForm.get('tagName').valueChanges.
      pipe(tap(val => {
        if (val == "" || val == null) {  // Showing history when search input is empty
          return
        }
      }),
        debounceTime(100)
      ).subscribe((suc) => {   // Getting the suggestions for the keyword/query typed in the input field.
        this.showTagsSuggestion(event);
      })
  }

  async showTagsSuggestion(event) {
    if(this.tagName && this.tagName.length == 0){
      this.implRef.showTagAutoSuggestion = false;
      return
    }
    if(event?.keyCode == 8 || event?.keyCode == 46 ){
      this.implRef.showTagAutoSuggestion = false;
    }else{
      if (this.tagName && this.tagName.trim() != "" && this.tagName.length >=3) {
        console.log("passed tag",this.tagName)
        this.getTaggingSuggestionList(this.tagName.trim());
        return;
      }else{
        this.implRef.showTagAutoSuggestion = false;
      }
    }
  }
  hideTagsSuggestion(event){
    if(event.keyCode == 8 || event.keyCode == 46 ){
      this.implRef.showTagAutoSuggestion = false;
    }
  }

  async getTaggingSuggestionList(keyword:string){
    this.currentSuggestion = undefined;
    if(keyword != undefined) {
      keyword = keyword.trim();
    }
    try {
      let self = this;
      if (!keyword) {
        return;
      }
      keyword = keyword.trim();
      if (keyword && this.tagForm.valid) {
        self.tagSuggestions = await self.searchService.getTaggingSuggestionList(keyword);
        self.tagSuggestions.tagList.length > 0 ? self.implRef.showTagAutoSuggestion = true : self.implRef.showTagAutoSuggestion = false;
        console.log("tag suggestions after sorting the data",self.tagSuggestions);
      } 
    } catch (err) {
      this.implRef.showTagAutoSuggestion = false;
      console.log("error in fetching results for", keyword, err)
    }

  }

  goToNextResult(){
    var suggestions = this.tagSuggestions.tagList
    if(suggestions.length > 0){
        if(this.currentIndex == suggestions.length-1){
          this.currentIndex = 0;
        }else{
          this.currentIndex += 1;
        }
        this.currentSuggestion = suggestions[this.currentIndex];
        this.addFocusForSelectedObject();
    }
  }

  goToPreviousResult(){
    var suggestions = this.tagSuggestions.tagList
    if(suggestions.length > 0){
        if(this.currentIndex == 0){
          this.currentIndex = suggestions.length-1;
        }else{
          this.currentIndex -= 1;
        }
        this.currentSuggestion = suggestions[this.currentIndex];
        this.addFocusForSelectedObject();
    }
  }

  addFocusForSelectedObject(){
    this.implRef.currentTagName = this.currentSuggestion
    this.removeSelectionHightlight();
    setTimeout(() => {
      this.highlightSelectedCell(this.currentSuggestion)
    }, 1);
    this.scrollToSelectedHightlight();
  }

  highlightSelectedCell(id){
    $('#'+id).addClass("highlightSelection")
  }

  removeSelectionHightlight(){
    $(".suggestionRow").removeClass('highlightSelection')
  }

  resetCurrentIndexAndSuggestions(){
    this.currentSuggestion = undefined;
    this.currentIndex = -1;
    this.removeSelectionHightlight()
  }

  scrollToSelectedHightlight(){
    var id = this.currentSuggestion
    var element = document.getElementById(id);
    element.scrollIntoView();
  }
}
